<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Pilih Item</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <SearchBox v-model="searchMenu" placeholder="Cari Menu" class-add="w-full" />
        <LocalFilterLane :items="allItemCategories" class-add="my-3" @setCurrentItem="setCurrentItem" />
        <TableComponent>
          <TableHead>
            <TableRow>
              <TableHeadCell>Kode</TableHeadCell>
              <TableHeadCell>Nama Item</TableHeadCell>
              <TableHeadCell numeric>Jumlah dipesan</TableHeadCell>
              <TableHeadCell numeric>Sudah diretur</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow v-if="filteredItems.length == 0">
              <TableCell colspan="6" customClass="text-center italic text-gray-400 dark:text-gray-500" noTextColor>
                Belum ada data
              </TableCell>
            </TableRow>
            <template v-else v-for="(item) in filteredItems" :key="item.id">
              <TableRow alternateRow isBody>
                <TableCell>{{ item.code }}</TableCell>
                <TableCell>
                  <div class="flex items-center gap-1">
                    <label for="">{{ item.name }}</label>
                    <CheckCircleIcon v-if="selectedItem.filter((i) => i.id == item.id).length > 0" class="h-4 w-4 bg-success text-white rounded-full" />
                  </div>
                </TableCell>
                <TableCell numeric>{{ item.qty }}</TableCell>
                <TableCell numeric>{{ item.returnedQty }}</TableCell>
                <TableCell v-if="item.has_product_mix"></TableCell>
                <TableCell v-else noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                  <button v-if="selectedItem.filter((i) => i.id == item.id).length == 0 && item.qty > item.returnedQty" :id="'edit-data-' + item.id"
                    @click="choose(item)"
                    class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                    <CheckCircleIcon class="h-4 w-4 group-hover:text-green-700" />
                  </button>
                  <button v-if="selectedItem.filter((i) => i.id == item.id).length > 0 && item.qty > item.returnedQty" @click="removeItem(item)"
                    class="border border-gray-400 hover:border-red-700 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                    <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                  </button>
                  <span v-if="item.qty <= item.returnedQty" class="bg-danger text-white p-2 rounded-md">Sudah diretur semua</span>
                </TableCell>
              </TableRow>
              <template v-if="item?.has_product_mix && item?.product_mix?.length > 0">
                <TableRow v-for="(itemMix) in item?.product_mix" :key="itemMix.id" alternateRow isBody>
                  <TableCell customClass="pl-8 text-gray-500 dark:text-gray-400">
                    <div class="flex items-center gap-1">
                      <span class="text-gray-400">↳</span>
                      <span class="italic">{{ itemMix.code || '-' }}</span>
                    </div>
                  </TableCell>
                  <TableCell customClass="text-gray-500 dark:text-gray-400">
                    <div class="flex items-center gap-1">
                      <span class="italic">{{ itemMix.name }}</span>
                      <span v-if="itemMix.qty" class="text-xs text-gray-400">({{ itemMix.qty }}x)</span>
                    </div>
                  </TableCell>
                  <TableCell numeric>{{ itemMix.quantity || '-' }}</TableCell>
                  <TableCell numeric>{{ itemMix.returned_quantity || '0' }}</TableCell>
                  <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                    <button v-if="selectedItem.filter((i) => i.id == itemMix.id).length == 0" :id="'edit-data-' + itemMix.id"
                    @click="choose(itemMix)"
                    class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <CheckCircleIcon class="h-4 w-4 group-hover:text-green-700" />
                    </button>
                    <button v-if="selectedItem.filter((i) => i.id == itemMix.id).length > 0" @click="removeItem(itemMix)"
                    class="border border-gray-400 hover:border-red-700 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                    </button>
                    <span v-if="itemMix.qty <= itemMix.returnedQty" class="bg-danger text-white p-2 rounded-md">Sudah diretur semua</span>
                  </TableCell>
                </TableRow>
              </template>
            </template>
          </TableBody>
        </TableComponent>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <Button type="submit" label="Simpan" :loading="loading" @click="submit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import SubmitButton from '../form/SubmitButton.vue';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { CheckCircleIcon, TrashIcon } from '@heroicons/vue/24/outline';
import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import LocalFilterLane from '@/views/pages/new-transaction/order/LocalFilterLane.vue';
import { Button } from 'primevue';

export default {
  name: "ModalChooseReturnProduct",
  components: {
    SubmitButton,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
    CheckCircleIcon,
    TrashIcon,
    SearchBox,
    LocalFilterLane,
    Button,
  },
  props: {
    productSalesReturn: {
      type: Array,
      default: () => [],
    },
    salesReturn: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      showModal: true,
      selectedItem: [],
      selectedCategory: null,
      searchMenu: '',
      currentPage: 1,
      totalPages: 1,
      fields: ['qty'],
      validation: {
        qty: {
          valid: true,
          message: '',
        },
      },
    }
  },
  computed: {
    ...mapGetters("items", ["allItems"]),
    ...mapGetters("item_categories", ["allItemCategories"]),
    ...mapGetters("sales_returns", ["allSalesReturns"]),
    filteredItems() {
      // Filter item berdasarkan kategori yang dipilih
      let result = this.productSalesReturn;
      result = result.map((item) => {
        item.itemCategory = this.allItemCategories.find(
          (ic) => ic.id == this.allItems.find(
            (it) => it.id == item.id
          )?.item_category_id
        );
        item.details = this.allItems.find(
          (sr) => sr.id == item.id
        );
        
        // Get the total returned quantity for this item from returnedItemsSummary
        const returnedQty = this.returnedItemsSummary(item.id) || 0;
        item.returnedQty = returnedQty;
        
        return item;
      });
      
      console.log("filteredItems with returned quantities:", result);
      result = result.filter((item) => item.itemCategory !== undefined);
      if (this.searchMenu)
        result = result.filter(
          (item) =>
            item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
        );
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.itemCategory.id === this.selectedCategory
        );
      }
      return result;
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.$emit('closeModal');
      }
    },
  },
  methods: {
    // Calculate total quantity of items already returned with paid status
    returnedItemsSummary(item_id) {
      if (!this.allSalesReturns || this.allSalesReturns.length === 0) {
        return 0;
      }
      console.log("allSalesReturns", this.allSalesReturns, item_id);
      
      // Group by item_id and sum quantities
      return this.allSalesReturns.reduce((acc, salesReturn) => {
        const itemQty = salesReturn.details.find((detail) => detail.item_id == item_id)?.qty;
        acc = acc + Number(itemQty);
        return acc;
      }, 0);
    },
    async fetchSalesReturns() {
      try {
        // Fetch paid sales returns for this sales order
        await this.$store.dispatch("sales_returns/fetchSalesReturns", {
          sales_order_id: this.salesReturn.sales_order_id,
          status: 'paid',
        });
      } catch (error) {
        console.error('Error fetching sales returns:', error);
      }
    },
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    choose(item) {
      this.selectedItem = [...this.selectedItem, item];
    },
    removeItem(item) {
      this.selectedItem = this.selectedItem.filter((i) => i.id !== item.id);
    },
    setCurrentItem(item) {
      this.selectedCategory = item;
    },
    submit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.loading = true;
          this.$emit('submit', this.selectedItem);
        },
        reject: () => {
          this.loading = false;
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
  },
  async created() {
    await this.$store.dispatch("item_categories/fetchItemCategories", {
      limit: 1000,
      status: "active",
    });
    await this.$store.dispatch("items/fetchItems");
    await this.fetchSalesReturns();
  }
}
</script>
